/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router-dom';

function DevCard({ bio }) {
  return (
    <div className="card mb-2 bg-light mr-3 mt-4" style={{ width: '12rem', borderColor: '#202027' }}>
      <div className="card-body dev_card">
        <h5 className="card-title text-uppercase">{bio.name}</h5>
        <p className="card-text">{bio.professionalHeadline}</p>
        <Link to={`/dev/${bio.username}`} params={bio} className="btn btn-primary">
          View profile
        </Link>
      </div>
    </div>
  );
}

export default DevCard;
